"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokerService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const broker_repository_1 = require("./broker.repository");
const broker_address_entity_1 = require("../../../../service-lib/src/lib/entities/broker-address.entity");
const address_service_1 = require("../address/address.service");
const typeorm_1 = require("typeorm");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const look_up_repository_1 = require("../look-up/look-up.repository");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const helper_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/helper.utils");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils/masters-validation");
const constants_2 = require("../../../../service-lib/src/lib/constants");
let BrokerService = class BrokerService {
    constructor(brokerRepository, addressService, dataSource, lookUpRepository, lookUpValidation, masterValidation) {
        this.brokerRepository = brokerRepository;
        this.addressService = addressService;
        this.dataSource = dataSource;
        this.lookUpRepository = lookUpRepository;
        this.lookUpValidation = lookUpValidation;
        this.masterValidation = masterValidation;
    }
    /** Add a new broker with addresses */
    async createBroker(createBrokerDto, userId) {
        const queryRunner = this.dataSource.createQueryRunner();
        await queryRunner.connect();
        await queryRunner.startTransaction();
        try {
            // Check if the broker already exists
            const existingBroker = await this.brokerRepository.findBrokerByName(createBrokerDto.brokerName);
            if (existingBroker) {
                throw new common_1.ConflictException(`A broker with the name "${createBrokerDto.brokerName}" already exists.`);
            }
            await this.masterValidation.validateMasterIds(createBrokerDto, constants_1.MASTER_DATA);
            await this.lookUpValidation.validateDynamicLookupValues(createBrokerDto, constants_1.LOOK_UP_DATA);
            // Set default status and metadata
            const brokerStatus = await this.lookUpRepository.findByLookUpKey(constants_1.DEFAULT_BROKER_STATUS_ACTIVE);
            // Set metadata fields
            createBrokerDto.statusLid = brokerStatus[0].id;
            createBrokerDto.createdAt = new Date();
            createBrokerDto.updatedAt = new Date();
            createBrokerDto.createdBy = userId;
            createBrokerDto.updatedBy = userId;
            // Add broker
            const broker = await this.brokerRepository.addBroker(queryRunner, createBrokerDto);
            // Save address details
            const addressMappings = [];
            if (createBrokerDto.address && createBrokerDto.address.length > 0) {
                for (const addressDto of createBrokerDto.address) {
                    const address = await this.addressService.addAddress(addressDto, userId);
                    const brokerAddress = new broker_address_entity_1.BrokerAddress();
                    brokerAddress.brokerId = broker.id;
                    brokerAddress.addressId = address.id;
                    await this.brokerRepository.addBrokerAddress(queryRunner, brokerAddress);
                    addressMappings.push(address);
                }
            }
            // Commit the transaction
            await queryRunner.commitTransaction();
            const brokerDetails = await this.brokerRepository.fetchBrokerById(broker.id);
            if (!brokerDetails) {
                throw new common_1.NotFoundException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToAddBroker));
            }
            const response = {
                ...brokerDetails,
            };
            // Remove metadata fields from the response
            (0, response_utils_1.removeMetadataFields)(response);
            return response;
        }
        catch (error) {
            await queryRunner.rollbackTransaction();
            if (error instanceof common_1.HttpException) {
                throw error;
            }
            if (error instanceof common_1.ConflictException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToAddBroker));
        }
        finally {
            await queryRunner.release();
        }
    }
    /** Get all brokers */
    async getAllBrokers(page, limit, sortBy, search, searchBy, userId) {
        try {
            const searchParams = (0, helper_utils_1.mapSearchParams)(search || "");
            const sortParams = (0, helper_utils_1.mapSortParams)(sortBy);
            if (sortParams) {
                const brokerSortOrderSearch = sortParams.find((item) => item.field === constants_2.sortRealtionsMapping.PARENT_BROKER_CITY_SORT_KEY);
                if (brokerSortOrderSearch) {
                    brokerSortOrderSearch.field =
                        constants_2.sortRealtionsMapping.PARENT_BROKER_CITY_SORT;
                }
                const brokerSortOrderStateSearch = sortParams.find((item) => item.field === constants_2.sortRealtionsMapping.PARENT_BROKER_STATE_SORT_KEY);
                if (brokerSortOrderStateSearch) {
                    brokerSortOrderStateSearch.field =
                        constants_2.sortRealtionsMapping.PARENT_BROKER_STATE_SORT;
                }
                const brokerSortOrderPhoneNumberSearch = sortParams.find((item) => item.field ===
                    constants_2.sortRealtionsMapping.PARENT_BROKER_PHONE_NUMBER_SORT_KEY);
                if (brokerSortOrderPhoneNumberSearch) {
                    brokerSortOrderPhoneNumberSearch.field =
                        constants_2.sortRealtionsMapping.PARENT_BROKER_PHONE_NUMBER_SORT;
                }
            }
            const { data, count } = await this.brokerRepository.fetchAllBrokers(page, limit, searchParams, sortParams, searchBy, userId);
            (0, response_utils_1.removeMetadataFields)(data);
            return {
                brokers: data,
                total: count,
                totalBrokers: count,
            };
        }
        catch (error) {
            console.error("Error fetching brokers:", error);
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToFetchBrokers || error.message));
        }
    }
    /** Get a single broker by ID */
    async getBrokerById(brokerId) {
        try {
            const broker = await this.brokerRepository.fetchBrokerById(brokerId);
            if (!broker) {
                throw new common_1.NotFoundException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokerNotFound));
            }
            (0, response_utils_1.removeMetadataFields)(broker);
            return broker;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToFetchBrokers));
        }
    }
    /** Modify a broker */
    async modifyBroker(brokerId, updateBrokerDto, userId) {
        const queryRunner = this.dataSource.createQueryRunner();
        await queryRunner.connect();
        await queryRunner.startTransaction();
        try {
            const broker = await this.brokerRepository.getBrokerById(brokerId);
            if (!broker) {
                throw new common_1.NotFoundException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokerNotFound));
            }
            await this.lookUpValidation.validateDynamicLookupValues(updateBrokerDto, constants_1.LOOK_UP_DATA);
            // Filter out the `address` field before updating the broker
            const { address, ...brokerDetails } = updateBrokerDto;
            brokerDetails.updatedBy = userId;
            brokerDetails.updatedAt = new Date();
            // Update the broker details using a transaction
            const updatedBroker = await this.brokerRepository.modifyBroker(queryRunner, brokerId, brokerDetails);
            // Handle address updates
            const addressMappings = [];
            if (address) {
                // retrieves the existing address
                const existingAddressIds = await this.brokerRepository.getEntityTableMapIds(constants_2.BROKER_MAP_TABLE_DELETE_FIELDS.BROKER_ADDRESS, constants_2.BROKER_MAP_TABLE_DELETE_FIELDS.ADDRESS_ID, { brokerId: brokerId });
                if (address.length > 0) {
                    for (const addressDto of address) {
                        let updatedAddress;
                        if (addressDto.id) {
                            const index = existingAddressIds.indexOf(addressDto.id);
                            if (index !== -1) {
                                existingAddressIds.splice(index, 1);
                            }
                            updatedAddress = await this.addressService.updateAddressById(addressDto.id, addressDto, userId);
                        }
                        else {
                            updatedAddress = await this.addressService.addAddress(addressDto, userId);
                            const brokerAddress = new broker_address_entity_1.BrokerAddress();
                            brokerAddress.brokerId = brokerId;
                            brokerAddress.addressId = updatedAddress.id;
                            // Add broker address using transaction
                            await this.brokerRepository.addBrokerAddress(queryRunner, brokerAddress);
                        }
                        addressMappings.push(updatedAddress);
                    }
                }
                await this.brokerRepository.deleteEntityTableMapIds(constants_2.BROKER_MAP_TABLE_DELETE_FIELDS.BROKER_ADDRESS, existingAddressIds, constants_2.BROKER_MAP_TABLE_DELETE_FIELDS.ADDRESS_ID, constants_1.MAPPED_DATA_DELETION.MAP_REMOVED);
            }
            // Commit the transaction
            await queryRunner.commitTransaction();
            const response = {
                ...updatedBroker,
                address: addressMappings,
            };
            // Remove metadata fields from the response
            (0, response_utils_1.removeMetadataFields)(response);
            return response;
        }
        catch (error) {
            // Rollback the transaction in case of an error
            await queryRunner.rollbackTransaction();
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            else if (error instanceof common_1.HttpException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToUpdateBroker));
        }
        finally {
            // Release the query runner
            await queryRunner.release();
        }
    }
    /** Delete a broker by ID */
    async deleteBroker(brokerId) {
        try {
            const broker = await this.brokerRepository.getBrokerById(brokerId);
            if (!broker) {
                throw new common_1.NotFoundException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokerNotFound));
            }
            await this.brokerRepository.softDeleteBroker(brokerId);
            return { message: messages_1.successMessage.brokerDeleted };
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToDeleteBroker));
        }
    }
    // Gets a list of brokers with pagination and sorting.
    async getBrokerList(page, limit, search, sortBy, sortOrder, userId) {
        try {
            const broker = await this.brokerRepository.fetchBrokerList(page, limit, search, sortBy, sortOrder, userId);
            return broker;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchBrokers));
        }
    }
    /** Get broker details by ID */
    async getBrokerDetails(id, userId) {
        try {
            const fields = ["id", "brokerName", "displayName", "createdAt"];
            const relations = ["brokerAddresses.address"];
            const whereCondition = { id };
            const brokerDetails = await this.brokerRepository.fetchBrokerDetails(fields, relations, whereCondition);
            if (!brokerDetails) {
                throw new common_1.NotFoundException(messages_1.errorMessages.brokerNotFound);
            }
            // Transform the data to include only required fields
            const transformedData = {
                id: brokerDetails.id,
                brokerName: brokerDetails.brokerName,
                displayName: brokerDetails.displayName,
                brokerAddresses: brokerDetails.brokerAddresses?.map((address) => ({
                    id: address.address?.id,
                    address1: address.address?.address1,
                    city: address.address?.cityId,
                })),
            };
            return transformedData;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchBrokers));
        }
    }
    /** Fetches broker contacts by broker ID. */
    async getBrokerContacts(brokerId) {
        try {
            const brokerContacts = await this.brokerRepository.fetchBrokerContacts(brokerId);
            if (!brokerContacts || brokerContacts.length === 0) {
                return [];
            }
            // Transform the data to return only necessary fields
            return brokerContacts.map((contact) => ({
                id: contact.id,
                firstName: contact.firstName,
                lastName: contact.lastName,
                displayName: contact.displayName,
            }));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchBrokerContacts));
        }
    }
};
exports.BrokerService = BrokerService;
exports.BrokerService = BrokerService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof broker_repository_1.BrokerRepository !== "undefined" && broker_repository_1.BrokerRepository) === "function" ? _a : Object, typeof (_b = typeof address_service_1.AddressService !== "undefined" && address_service_1.AddressService) === "function" ? _b : Object, typeof (_c = typeof typeorm_1.DataSource !== "undefined" && typeorm_1.DataSource) === "function" ? _c : Object, typeof (_d = typeof look_up_repository_1.LookUpRepository !== "undefined" && look_up_repository_1.LookUpRepository) === "function" ? _d : Object, typeof (_e = typeof lookup_validation_1.LookUpValidationService !== "undefined" && lookup_validation_1.LookUpValidationService) === "function" ? _e : Object, typeof (_f = typeof masters_validation_1.MasterValidationService !== "undefined" && masters_validation_1.MasterValidationService) === "function" ? _f : Object])
], BrokerService);
